import adminEn from '../../admin/i18n/languages/admin.en';
import baseEn from '../../base/i18n/languages/base.en';

const en = {
  translation: {
    general: {
      loading: 'Loading...',
      error: 'An error occured.',
      noData: 'There is nothing to show.',
      yes: 'Yes',
      no: 'No',
      true: 'True',
      false: 'False',
      or: 'or',
      search: 'Search',
      null: '-',
    },
    ...adminEn.translation,
    ...baseEn.translation,
  },
};

export default en;
